import React from 'react'
import { Grid, GridItem, Text } from '@chakra-ui/react'
import { SectionAccordion } from '../../UI'
import PartnerInformation from './PartnerInformation'
import ApplicationInformation from './ApplicationInformation'
import PostulantInformation from './PostulantInformation'
import Documents from './Documents'
import AdditionalInformations from './AdditionalInformations'
import RenderFlowDocuments from '../RenderFlowDocuments'
import { haveDocuments } from '../../../Utils'

const TechnicalProfessionalScholarships = ({ program }) => {
  const renderViewTitle = (title) => (
    <Text
      fontWeight={700}
      bg={'green.100'}
      color={'white'}
      fontSize={20}
      borderRadius={8}
      px={5}
      py={1}
      my={4}
    >
      {title}
    </Text>
  )

  const documentsInProgram = haveDocuments(
    [
      'birthCertificate',
      'scoreCertificate',
      'applicationSignedByPartner',
      'motivationLetter',
      'parentsLastSalary',
      'socialReport',
      'socialReport',
      'scoreCertificateSantoTomas'
    ],
    program
  )

  return (
    <Grid templateColumns={'repeat(1, minmax(0, 1fr))'} gap={2}>
      <GridItem>
        {renderViewTitle('Información del socio')}
        <PartnerInformation program={program} />
      </GridItem>
      <GridItem>
        {renderViewTitle('Información de la solicitud')}
        <ApplicationInformation program={program} />
      </GridItem>
      <GridItem>
        {renderViewTitle('Información del postulante a beca')}
        <PostulantInformation program={program} />
      </GridItem>
      <GridItem>
        {documentsInProgram && renderViewTitle('Documentos adjuntos')}
        <Documents program={program} />
      </GridItem>

      {program?.aditionalDocuments.length > 0 || program?.observations ? (
        <GridItem>
          {renderViewTitle('Observaciones de la solicitud')}
          <AdditionalInformations program={program} />
        </GridItem>
      ) : null}

      <SectionAccordion title={'Documentos agregados dentro del flujo'}>
        <GridItem>
          <RenderFlowDocuments program={program} />
        </GridItem>
      </SectionAccordion>
    </Grid>
  )
}

export default TechnicalProfessionalScholarships
